export default __webpack_public_path__ + "img/32f267e01dfe40f75eb92652f07b0aec.png";